'use client'

import { useEffect } from 'react'

import { type Metadata } from '@redteclab/api/clients/retail-media-xsell-service'

import { AD_SERVER_XSELL_PRODUCT_ID_DATA_ATTR } from './adServerConst'
import { adServerSlotsPushSetupPreloadedSlotsCommand } from './adServerSlots'
import { type AdServerSetupPreloadedSlot } from './model/adServerTypes'

export const useRecommendationPreloadedSlotsPush = (
  rootElement: Element | null,
  metadata?: Metadata,
): void => {
  useEffect(() => {
    if (!rootElement || !metadata) {
      return
    }

    /*
     * Collect all re-ranked / injected elements and push them into ad server data layer.
     * Intersection observer on the ad server client triggers action when
     * user scrolls / has recommendations in the browser window view.
     */
    const recommendationItemElements = [
      ...rootElement.querySelectorAll(
        `[${CSS.escape(AD_SERVER_XSELL_PRODUCT_ID_DATA_ATTR)}]`,
      ),
    ]

    if (recommendationItemElements.length === 0) {
      return
    }

    const slotMetadataContentPair: AdServerSetupPreloadedSlot[] = []

    for (const element of recommendationItemElements) {
      const productId = element.getAttribute(
        AD_SERVER_XSELL_PRODUCT_ID_DATA_ATTR,
      )
      const metadataContent = metadata[productId as keyof Metadata]

      if (metadataContent && productId) {
        slotMetadataContentPair.push({
          metadataContent: {
            ...metadataContent,
            productId,
          },
          slot: element,
        })
      }
    }

    if (slotMetadataContentPair.length > 0) {
      adServerSlotsPushSetupPreloadedSlotsCommand(slotMetadataContentPair)
    }
  }, [rootElement, metadata])
}
